import { useState } from 'react';
import { pastorApi, errorMessage } from '../pastorApi';
import { CONSULT_PHONE, KAKAO_CHANNEL_URL } from '../pastorOptions';

// 웹이 익숙지 않은 지방 교회를 위한 '청빙 대행 상담' — 전화 / 카카오톡 / 연락처 남기기
export default function ConsultFloating() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ churchName: '', contactName: '', phone: '', region: '', memo: '' });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  const set = (key: keyof typeof form) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async () => {
    setError('');
    setSending(true);
    try {
      await pastorApi.consult(form);
      setDone(true);
    } catch (e) {
      setError(errorMessage(e, '접수하지 못했습니다. 카카오톡으로 문의해 주세요.'));
    } finally {
      setSending(false);
    }
  };

  const close = () => {
    setOpen(false);
    setDone(false);
    setError('');
  };

  return (
    <>
      <button type="button" className="pc-float" onClick={() => setOpen(true)} aria-label="청빙 대행 상담">
        <span className="pc-float__title">청빙 대행 상담</span>
        <span className="pc-float__sub">전화·카톡으로 대신 찾아드려요</span>
      </button>

      {open && (
        <div className="pc-modal-overlay" onClick={close}>
          <div className="pc-modal pc-modal--narrow" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
            <div className="pc-modal__head">
              <h3>담임목사 청빙 대행 상담</h3>
              <button type="button" className="pc-modal__close" onClick={close} aria-label="닫기">✕</button>
            </div>
            <div className="pc-modal__body">
              <p className="pc-lead">
                인터넷 사용이 어려우셔도 괜찮습니다. 교회 사정을 말씀해 주시면 사역자모아가 인재풀에서
                목사님을 찾아 대신 제안해 드립니다.
              </p>

              <div className="pc-consult__channels">
                {CONSULT_PHONE && (
                  <a className="mm-btn mm-btn--primary pc-btn-lg" href={`tel:${CONSULT_PHONE.replace(/[^\d]/g, '')}`}>
                    전화 상담 {CONSULT_PHONE}
                  </a>
                )}
                <a className="mm-btn mm-btn--outline pc-btn-lg pc-kakao" href={KAKAO_CHANNEL_URL} target="_blank" rel="noreferrer">
                  카카오톡 채널로 상담하기
                </a>
              </div>

              <div className="pc-divider"><span>또는 연락처를 남겨 주시면 전화드립니다</span></div>

              {done ? (
                <div className="pc-done">
                  <p className="pc-done__title">상담 신청이 접수되었습니다</p>
                  <p>영업일 기준 1~2일 안에 남겨 주신 번호로 연락드리겠습니다.</p>
                </div>
              ) : (
                <div className="pc-form pc-form--compact">
                  <label className="pc-field">
                    <span>교회명 *</span>
                    <input className="mm-field" value={form.churchName} onChange={set('churchName')} placeholder="예) 은혜교회" />
                  </label>
                  <label className="pc-field">
                    <span>성함·직분 *</span>
                    <input className="mm-field" value={form.contactName} onChange={set('contactName')} placeholder="예) 김OO 장로" />
                  </label>
                  <label className="pc-field">
                    <span>연락처 *</span>
                    <input className="mm-field" value={form.phone} onChange={set('phone')} placeholder="010-0000-0000" inputMode="tel" />
                  </label>
                  <label className="pc-field">
                    <span>지역</span>
                    <input className="mm-field" value={form.region} onChange={set('region')} placeholder="예) 경북 의성군" />
                  </label>
                  <label className="pc-field">
                    <span>교회 사정</span>
                    <textarea className="mm-field" rows={3} value={form.memo} onChange={set('memo')} placeholder="출석 인원, 사택 여부, 원하시는 목사님 등 편하게 적어 주세요" />
                  </label>
                  {error && <p className="pc-error">{error}</p>}
                  <button type="button" className="mm-btn mm-btn--primary pc-btn-lg mm-btn--block" disabled={sending} onClick={submit}>
                    {sending ? '접수 중…' : '전화 상담 요청하기'}
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}
